/**
* @name: regExp.js
* @description: 常用到的正则集合
* @author: 秦鹏森
* @create: 2020/07/31 13:54:06
* @update: 2020/07/31 13:54:06
*/

const reg = {
  empty: /^\s*$/,
  phone: /^1\d{10}$/,
  telnum: /^1\d{10}$|^(\d{3,4}-?)?\d{7,8}$/,
  email: /^\w+[\w-+.]*@[\w-]+(\.[\w-]+)+$/,
  money1: /^(-?|\+?)\d+(\.\d{1,2})?$/,
  money: /^\d+(\.\d{1,2})?$/,
  integer: /^-?([1-9]\d*|0)$/,
  integer1: /^(-?|\+?)([1-9]\d*|0)$/,
  illegal: /[<>]/,
  percent: /^0$|^[1-9]\d?$|^100$/,
  url: /^((https?|ftp):\/\/)?[\w-]+\.[\w-]+(\.[\w-]+)*/
};
export default reg;
